// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__OGrAL","Footer__div":"Footer_Footer__div__vOoua","first":"Footer_first__EXw95","second":"Footer_second__0ia75","p":"Footer_p__Ihyt9"};